var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6562 15.4531H26.2703L21.5 1.34375L16.7297 15.4531H1.34375L13.7734 24.1875L9.00312 38.2969L21.5 29.5625L33.9297 38.2969L29.1594 24.1875L41.6562 15.4531Z",
    fill: "#FFCE31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0405 13.6391L33.728 5.97968L26.6733 10.8172L27.6812 13.6391H31.0405Z",
    fill: "#FFDF85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7454 33.5937L21.5 41.6562L24.2547 33.5937L21.5 31.7125L18.7454 33.5937Z",
    fill: "#FFDF85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0641 23.0453L31.511 24.7922L32.586 28.0172H41.2532L34.0641 23.0453Z",
    fill: "#FFDF85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3264 10.8172L9.27173 5.97968L11.9592 13.6391H15.3186L16.3264 10.8172Z",
    fill: "#FFDF85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93589 23.0453L1.74683 28.0172H10.414L11.489 24.7922L8.93589 23.0453Z",
    fill: "#FFDF85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a5dbb6acbc0ec0a362131e15bd36c4e8.svg";
export { ForwardRef as ReactComponent };